const Variant = {
    PLAIN: "PLAIN",
    WITH_KEYWORDS: "WITH_KEYWORDS",
}

export default Variant;